<template>
    <div class="modal fade" id="reorder_elements_modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="margin-bottom0">Reorder your elements</h5>

                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <ul class="list-group">
                        <draggable v-model="elements" @start="drag=true" @end="drag=false">
                            <li v-for="element in elements" class="list-group-item padding-x10 padding-y5">
                                {{ element.name }}
                                <span class="badge badge-light pull-right"><i class="fa fa-sort" aria-hidden="true"></i></span>
                            </li>
                        </draggable>
                    </ul>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    export default {
        computed: {
            elements: {
                get() {
                    return this.$store.getters.getBuilderElements;
                },

                set(elements) {
                    this.$store.commit('setBuilderElements', elements);
                }
            }
        }
    }        
</script>

<style lang="scss">
    #reorder_elements_modal {
        li {
            cursor: move;
        }

        .badge {
            font-weight: 500;
            margin-top: .3rem;
            font-size: 1.3rem;
        }

        .btn-success {
            margin: 0 auto;
        }
    }
</style>

